import React from 'react';
import { AllClaims } from '../../components/client/AllClaims';

export const Completed2 = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Completed";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
